<template lang="html">
  <h1 class="title">{{ $t('error.404') }}</h1>
</template>

<script>
module.exports = {};
</script>
